import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import Markdown from 'markdown-to-jsx';

class Onelog extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      headerBgClass: '',
      headerTextClass: ''
    };
  }

  componentDidMount () {
    let bgClass = 'bg-next';
    let textClass = 'text-dark';

    switch (this.props.log.update_type) {
      case 'major':
        bgClass = 'bg-primary';
        textClass = 'text-light';
        break;
      case 'minor':
        bgClass = 'bg-secondary';
        textClass = 'text-light';
        break;
      case 'patch':
        bgClass = 'bg-info';
        textClass = 'text-light';
        break;
      default:
        break;
    }

    this.setState({
      headerBgClass: bgClass,
      headerTextClass: textClass
    });
  }

  render () {
    return (
      <Card className="border border-admin m-4">
        <Card.Header className={`d-flex align-items-center p-3 text-light card-title ${this.state.headerBgClass}`}>
          <span className="h4 font-weight-bold">{this.props.log.version}</span>
          <span className="ml-3 mb-1">{this.props.log.update_type}</span>
          <span className={`ml-auto mr-3 mb-1 ${this.state.headerTextClass}`}>
            {this.props.log.created_at.slice(0, 10)}
          </span>
        </Card.Header>
        <Card.Body>
          <Markdown>{this.props.log.content}</Markdown>
        </Card.Body>
        { this.props.log.revision && (
          <Card.Footer>
            <span style={{fontSize: 10}}>{this.props.log.revision}</span>
          </Card.Footer>
        )}
      </Card>
    );
  }
}

Onelog.propTypes = {
  log: PropTypes.object
};

export default Onelog;
